import { render, staticRenderFns } from "./observe-config.vue?vue&type=template&id=02fa78ee&scoped=true"
import script from "./observe-config.vue?vue&type=script&lang=js"
export * from "./observe-config.vue?vue&type=script&lang=js"
import style0 from "./observe-config.vue?vue&type=style&index=0&id=02fa78ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa78ee",
  null
  
)

export default component.exports